import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import SearchFormIndex from './search';

const RightPanel = () => {
  const justAsk = useSelector((state) => state.justAsk)
  const [justAskContent, setjustAskContent] = useState(true)

  useEffect(() => {
    if (justAsk?.displayContent) {
      setjustAskContent(true)
    } else {
      setjustAskContent(false)
    }
  }, [justAsk?.displayContent])

  return (
    <>
      {justAskContent ? (
        <Container className="content">
          <Row>
            <Col xs="12" className="text-center">
              <div className="icon" />
            </Col>
          </Row>
          <Row>
            <Col xs="12" className="text-start">
              <p>Just Ask uses AI-powered search to make finding your ideal projects easier than ever with Barbour ABI.</p>
              <p>Simply ask a question like you would ask a colleague and Just Ask will return the projects that answer your needs.</p>
              <h3>How it works:</h3>
              <ul>
                <li>Make a clear prompt. Say something like, “show me projects in Manchester starting next year”.</li>
                <li>Just Ask will deliver every project that meets your criteria.</li>
                <li>If you want to get more specific, then simply refine your search further. E.g. “only include projects worth £10m and above”.</li>
                <li>Your pool of results will narrow to meet your new needs.</li>
                <li>You can continue to refine until you’re left with only your ideal projects.</li>
                <li>If you already know exactly which projects you want to see, then you can be as specific as you want to be from your very first prompt.</li>
              </ul>
              <p>If you need some inspiration, try out our example searches.</p>
              <p>After that, all you need to do to get started is Just Ask.</p>
            </Col>
          </Row>
        </Container>
      ) : (
        <SearchFormIndex />
      )}
    </>
  );
};

export default RightPanel;
